import React from "react";
import { ClipboardCheckIcon, FileTextIcon, GitBranchIcon, Grid3x3Icon, ImageIcon } from "lucide-react";
import { CtaButton } from "../CtaButton";
import { SectionHeading } from "../SectionHeading";
import { tools } from "../../data/content";
const toolIcons = [FileTextIcon, ClipboardCheckIcon, GitBranchIcon, Grid3x3Icon, ImageIcon];
export function ToolsSection() {
  return <section className="bg-white px-5 py-16 sm:py-24" aria-label="Professional tools" data-id="element-341" data-mp="1nzwzteoqybrh">
      <div className="mx-auto max-w-4xl" data-id="element-342" data-mp="1sqdboucx5pbq">
        <SectionHeading eyebrow="Plus, you'll receive these professional tools" title="Designed to Make the System Easier to Use, Revisit, and Print" data-id="element-343" data-mp="1sreyfw3as09a" />

        <ul className="mt-12 divide-y divide-ink/10 border-y border-ink/10" data-id="element-344" data-mp="1j00unc4bceac">
          {tools.map((t, i) => {
          const Icon = toolIcons[i];
          return <li key={t.title} className="flex gap-4 py-6" data-id="element-345" data-mp="192cxkfj8iup0" data-mpi={i}>
                <span className="flex h-12 w-12 shrink-0 items-center justify-center rounded-xl bg-brand-soft text-brand" data-id="element-346" data-mp="191uvv3dszo9p">
                  <Icon className="h-6 w-6" aria-hidden="true" data-id="element-347" data-mp="1rukwxe01s8a9" />
                </span>
                <div data-id="element-348" data-mp="1mteyr0nmbstc">
                  <h3 className="font-serif text-xl sm:text-2xl font-bold text-ink" data-id="element-349" data-mp="21qxni30aq60s">{t.title}</h3>
                  <p className="mt-1.5 text-base sm:text-[17px] leading-relaxed text-ink/75" data-id="element-350" data-mp="1wrutreprnm84">{t.text}</p>
                </div>
              </li>;
        })}
        </ul>

        <div className="mx-auto mt-10 max-w-2xl space-y-2 text-center text-lg text-ink/80" data-id="element-351" data-mp="1905xjn9tqdlw">
          <p data-id="element-352" data-mp="14508wgp1eku4">Everything is designed for digital use, printing, and repeated educational review.</p>
          <p data-id="element-353" data-mp="1iteg13thkvgh">The goal is to give you a structured learning resource you can return to whenever you're studying otoplasty.</p>
        </div>

        <div className="mt-10" data-id="element-354" data-mp="qbiq4y46dc55">
          <CtaButton label="I want access to the complete system" data-id="element-355" data-mp="qahgmy2t4xpj" />
        </div>
      </div>
    </section>;
}